import { IBranchSettings } from "../../types/IBranchSettings";
import { defaultCardMachine } from "../../types/ICardMachine";
import { defaultOrganisation, IOrganisation } from "../../types/IOrganisation";
import { defaultPrinter, IPrinter } from "../../types/IPrinter";
import {
  defaultStyleSettings,
  IStyleSettings,
} from "../../types/IStyleSettings";
import { IConfiguration } from "./IConfiguration";

let branchSettings: IBranchSettings = {
  organisation: defaultOrganisation,
  printers: [defaultPrinter],
  styleSettings: defaultStyleSettings,
  cardMachines: [defaultCardMachine],
};

export class Configuration implements IConfiguration {
  public setSettings(s: IBranchSettings): void {
    branchSettings = s;
  }
  public getSettings(): IBranchSettings {
    return branchSettings;
  }
}
